// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fPeG","content":"styles_content__1mFgf","tableWrap":"styles_tableWrap__3wqdx"};